/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { clearCoverLetterData, fetchCoverLetter, selectCoverLetterData, setCoverLetterData } from '../../../store/slices/api/inner/coverLetter';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import { MdDownload } from 'react-icons/md';
import Main from '../../../components/HOC/Main';
import CustomTable from '../../../components/common/CustomTable';
import { formateDate } from '../../../components/common/FormateDate';

export const CoverLetterPage = () => {

  const coverLetterData = useSelector(selectCoverLetterData);

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchCoverLetter,
    setValueAction: setCoverLetterData,
    clearValueActionOnError: clearCoverLetterData,
    isForm: false,
    successMessage: false,
  });

  const handleDownload =()=>{

  }
  const columns = useMemo(() => [

    {
      accessorKey: 'user',
      cell: info => <div>{info.getValue()?.name} {info.getValue()?.surname}</div>,
      filterFn: 'includesStringSensitive',
    },
    {
      accessorKey: 'updatedAt',
      cell: info => formateDate(info.getValue()),
      filterFn: 'includesStringSensitive',
      'label':'Last updated'
    },
    {
      accessorKey: 'createdAt',
      cell: info => formateDate(info.getValue()),
      filterFn: 'includesStringSensitive',
    },
    {
      id: 'actions',
      cell: info =>  <button 
      className='rounded-md h-8 w-8 flex items-center justify-center border-2 border-blue-600 text-blue-500'
      onClick={() => handleDownload(info.row.original.coverLetter_id)}
    >
      <MdDownload />
    </button>
    },
 
  ], []);

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <Main crumbs={[{ title: "user" },{title:"coverLetter"}]} >
      <CustomTable columns={columns} data={coverLetterData} 
       />
    </Main>
  );
};
